import React from "react";
import { Controller, ControllerProps } from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";

export interface TextFieldControlProps extends
	Omit<ControllerProps<any, any>, "defaultValue" | "name" | "render">,
	Omit<TextFieldProps, "variant">
{
	variant?: TextFieldProps["variant"],
}

export function TextFieldControl(props: TextFieldControlProps) {
	const {
		control,
		disabled,
		defaultValue,
		helperText,
		name,
		rules,
		shouldUnregister,
		variant = "standard",
		...textFieldProps
	} = props;
	const inputEl = React.useRef<HTMLInputElement>();
	return (
		<Controller
			control={control}
			defaultValue={defaultValue}
			name={name}
			render={renderProps => {
				const { field, fieldState, formState } = renderProps;
				return (
					<TextField
						{...textFieldProps}
						disabled={disabled || formState.isSubmitting}
						error={Boolean(fieldState.error)}
						helperText={fieldState.error?.message ?? helperText}
						name={field.name}
						inputRef={inputEl}
						onBlur={e => {
							textFieldProps.onBlur?.(e);
							field.onBlur();
						}}
						onChange={e => {
							textFieldProps.onChange?.(e);
							field.onChange(e);
						}}
						value={textFieldProps.value ?? field.value}
						variant={variant}
					/>
				);
			}}
			rules={rules}
			shouldUnregister={shouldUnregister}
		/>
	);
}
